<template>
	<div id="bgmap"></div>
</template>

<script>
	import MapUtil from '../../utils/mapUtil';
	import "echarts-extension-amap";
	//let symbolSize = 24;
	var entColorList = ['#eb2100', '#00C31b', '#36C', "#f60"];
	var arroundColorList = ['#eb2100', '#36C', ];
	var entNameList = ['龙头企业', '创新企业', '优质企业', ""];
	var aroundNameList = ['当前企业', '周边企业', ""];
	var currentNameList = [],
		currentColorList = [],
		currentSvg="";
	export default {
		name: "BGMap",
		props: {
			arround: {
				type: Boolean,
				default: false,
			},
			type: {
				type: String, //enterprise arroundEnterprise  building land
				default: 'enterprise',
			},
			autoLocation: {
				type: Boolean,
				default: true,
			},
			viewMode: {
				type: String,
				default: '2D',
			},
		},
		data() {
			return {
				nameColor:{
					enterprise:{
						name:['龙头企业', '创新企业', '优质企业',""],
						color:['#eb2100', '#00C31b', '#36C',"#f60"],
						svg:'path://M19.72,10.2a4.51,4.51,0,0,0-4.66-4.49,4.67,4.67,0,0,0-4.78,4.49,5.44,5.44,0,0,0,1.44,3.61h0l.22.22.09.09a17.87,17.87,0,0,1,2.25,2.52A8.75,8.75,0,0,1,15,18.2a8,8,0,0,1,.73-1.55,18.08,18.08,0,0,1,2.17-2.43A5.54,5.54,0,0,0,19.72,10.2Z',
					},
					arroundEnterprise:{
						name:['当前企业', '周边企业', ""],
						color:['#eb2100', '#36C', ],
						svg:"path://M19.72,10.2a4.51,4.51,0,0,0-4.66-4.49,4.67,4.67,0,0,0-4.78,4.49,5.44,5.44,0,0,0,1.44,3.61h0l.22.22.09.09a17.87,17.87,0,0,1,2.25,2.52A8.75,8.75,0,0,1,15,18.2a8,8,0,0,1,.73-1.55,18.08,18.08,0,0,1,2.17-2.43A5.54,5.54,0,0,0,19.72,10.2Z",
					},
					building:{
						name:['楼宇',""],
						color:['#eb2100', ],
						svg:"path://M19.72,10.2a4.51,4.51,0,0,0-4.66-4.49,4.67,4.67,0,0,0-4.78,4.49,5.44,5.44,0,0,0,1.44,3.61h0l.22.22.09.09a17.87,17.87,0,0,1,2.25,2.52A8.75,8.75,0,0,1,15,18.2a8,8,0,0,1,.73-1.55,18.08,18.08,0,0,1,2.17-2.43A5.54,5.54,0,0,0,19.72,10.2Z",
						// svg:"image://@/assets/images/gps_building.svg",
					},
					land:{
						name:['拿地项目',""],
						color:['#eb2100', ],
						svg:"path://M19.72,10.2a4.51,4.51,0,0,0-4.66-4.49,4.67,4.67,0,0,0-4.78,4.49,5.44,5.44,0,0,0,1.44,3.61h0l.22.22.09.09a17.87,17.87,0,0,1,2.25,2.52A8.75,8.75,0,0,1,15,18.2a8,8,0,0,1,.73-1.55,18.08,18.08,0,0,1,2.17-2.43A5.54,5.54,0,0,0,19.72,10.2Z",
					}
				},
				currentNameColor:{},
				chart: null,
				amap: null,
				option: null,
				mapUtil: null,
				list: [],
				moveTimerId: 0,
				symbolSize: 24,
				marker: null,
				cancelRefresh: false,
				symbolColor: '#36C',
				searchSymbolColor: '#F30',
				selectedSeriesIndex: 3,
				currentNameList: [],
			};
		},
		created() {
			
		},
		mounted() {
			this.init();
			if (this.arround) {
				console.log('周边城市，不需要分三种公司')
			}
		},
		methods: {
			geCurrentNameColor(){
				this.currentNameColor=this.nameColor[this.type];
				currentNameList =this.currentNameColor.name;
				currentColorList = this.currentNameColor.color;
				currentSvg=this.currentNameColor.svg;
				console.log(currentSvg);
			},
			getEnterpriseSeries() {
				var _this=this;
				var series = []; 
				for (var i = 1; i <= 3; i++) {
					series.push({
						name: currentNameList[i - 1],
						type: "scatter",
						coordinateSystem: "amap",
						symbol: "pin",
						symbolSize: this.symbolSize,
						data: [],
						itemStyle: {
							color: currentColorList[i - 1],
						},
						tooltip: {
							formatter: function(param) { 
								var data = param.data;
								var title=data.title; 
								if(_this.type == 'land'){ 
									title=data.projectName; 
								}
								var html = '<div class="company-tip">';
								html +=
									'<div class="company-title"><b>' +
									title +
									"</b></div>";
								// html +=
								//     '<div class="company-addr">' +
								//     data.address +
								//     "</div>";
								html += "</div>";
								return html;
							},
							transitionDuration: 0,
							//position: [10, 10],
							textStyle: {
								fontFamily: "Microsoft YaHei",
							},
						},
					})
				}
				series.push({
					//zlevel:99999,
					name: "",
					type: "scatter",
					rippleEffect: {
						//坐标点动画
						period: 2,
						scale: 4,
						brushType: "fill",
					},
					coordinateSystem: "amap",
					symbol: "pin",
					//symbol: img2,
					symbolSize: this.symbolSize,
					//symbolSize: [22, 28],
					pointSize: 5, // 设置 热力图 点 的大小
					blurSize: 5, // 设置点的 阴影半径
					data: [],
					itemStyle: {
						color: '#f60',
						borderColor: '#fff',
						borderWidth: 1,
					},
					tooltip: {
						formatter: function(param) {
							//console.log(param);
							var data = param.data;
							var title=data.title;
							var address=data.address;
							if(this.type == 'land'){ 
								title=data.projectName;
								address=data.purpose;
							}
							var html = '<div class="company-tip">';
							html +=
								'<div class="company-title"><b>' +
								title +
								"</b></div>";
							html +=
								'<div class="company-addr">' +
								 address+
								"</div>";
							html += "</div>";
							return html;
						},
						transitionDuration: 0,
						//position: [10, 10],
						textStyle: {
							fontFamily: "Microsoft YaHei",
						},
					},
				});
				return series;
			},
			init() {
				this.geCurrentNameColor();
				this.chart = this.$echarts.init(document.getElementById('bgmap'));
				
				var viewMode = this.viewMode;
				var legend = [];
				//周边企业 用aroundNamelist
				currentNameList.forEach((item, i) => {
					legend.push({
						name: item,
						itemStyle: {
							color: "rgba(0,0,0,0)",
						},
						textStyle: {
							color: '#FFF',
							fontSize: 14,
							padding: 4,
							backgroundColor: 'rgba(0,0,0,.5)',
						},
					})
				});
				this.option = {
					amap: {
						center: [114.064532, 22.548457], //[116.419791, 39.928879],
						zoom: 20,
						resizeEnable: true,
						renderOnMoving: true,
						echartsLayerInteractive: true,
						largeMode: false,
						pitch: 65, // 地图俯仰角度，有效范围 0 度- 83 度
						viewMode: viewMode, // 地图模式
					},
					tooltip: {
						trigger: "item",
					},
					visualMap: [],
					animation: false,
					legend: {
						show: true,
						data: legend,
						left: 15,
						bottom: 50,
						orient: 'vertical',
						// icon:"path://",
						icon:"path://M19.72,10.2a4.51,4.51,0,0,0-4.66-4.49,4.67,4.67,0,0,0-4.78,4.49,5.44,5.44,0,0,0,1.44,3.61h0l.22.22.09.09a17.87,17.87,0,0,1,2.25,2.52A8.75,8.75,0,0,1,15,18.2a8,8,0,0,1,.73-1.55,18.08,18.08,0,0,1,2.17-2.43A5.54,5.54,0,0,0,19.72,10.2Z" ,
						// symbol: 'pin',
						// textStyle:{
						//     color: '#fff',
						//     fontSize: 14,
						//     // padding: 4,
						// 				padding:[10,0,30,0],
						//     backgroundColor: 'rgba(0, 0, 0, .5)',
						// 				rich: {
						// 								a: {
						// 											verticalAlign: 'middle',
						// 								},
						// 				},
						// },
						//symbol: 'pin',
						// //height: 200,
						itemHeight: 20,
						itemWidth: 24,

						// data: entNameList,
					},
					series: this.getEnterpriseSeries(),
				}; //end of option
				this.chart.setOption(this.option);
				var amapComponent = this.chart.getModel().getComponent('amap');
				// Get the instance of AMap
				this.amap = amapComponent.getAMap();
				this.mapUtil = new MapUtil(this.amap, this.autoLocation, this.viewMode);
				if (this.autoLocation) {
					this.mapUtil.getLocation((position, area) => {
						this.onLocation(position, area);
					});

					this.bindMapEvent();
				}

			}, //end of init
			onLocation(position, area) {
				this.$emit('location', {
					position,
					area
				});
				//显示坐标
				if (!this.marker) { //http://a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png
					var icon = new AMap.Icon({
						imageSize: [24, 36],
						image: 'http://www.ocn.com.cn/imgs/position2.png?v=2022'
					});
					this.marker = new AMap.Marker({
						icon: icon,
						position: position,
						offset: new AMap.Pixel(-13, -30),
						dragable: true,
						labelx: {
							content: '我的位置'
						},
					});
					this.marker.setMap(this.amap);
				}
			},
			bindMapEvent() {
				this.amap.on("zoomchange", e => {
					var zoom = this.amap.getZoom();
					clearTimeout(this.moveTimerId);
					this.$emit('zoomchange', zoom);
					this.symbolSize = Math.min(Math.max(zoom * 2, 22), 38);
				});
				this.amap.on('mapmove', e => {
					var center = this.amap.getCenter();
					clearTimeout(this.moveTimerId);
					this.moveTimerId = setTimeout(_ => {
						this.$emit('mapmove', center)
					}, 500);
				});
				this.chart.on("click", e => {
					if (e.seriesType == "scatter") {
						this.$emit('selectitem', e.data);
					}
				});
			},
			setData(list) {
				this.list = list;
				this.showEnterprise();
			},
			setSearchData(list) {
				this.list = list;
				this.showEnterprise(true);
			},
			setAmapOption() {
				var center = this.amap.getCenter();
				this.option.amap.center = [center.lng, center.lat];
				this.option.amap.zoom = this.amap.getZoom();
				this.option.series[0].symbolSize = this.symbolSize;
				this.option.series[1].symbolSize = this.symbolSize;
				this.option.series[2].symbolSize = this.symbolSize;
				this.option.series[this.selectedSeriesIndex].symbolSize = this.symbolSize;
			},
			showEnterprise(isSearch) { 
				for (var i = 0; i < 3; i++) {
					var data = [];
					var list = this.list.filter(x => x.type == i + 1);
					list.forEach(item => {
						var o = {
							...item,
							value: [item.lng, item.lat, 10],
							itemStyle: {
								color: currentColorList[i],
							}
						};
						data.push(o);
					});
					this.option.series[i].data = data;
					// this.option.series[i].itemStyle.color = isSearch ? this.searchSymbolColor : this.symbolColor;
					// console.log('a,',i,this.option.legend.data[i].itemStyle, this.searchSymbolColor,this.symbolColor);
					// this.option.legend.data[i].itemStyle.color = isSearch ? this.searchSymbolColor : this.symbolColor;
					// console.log('b,',i,this.option.legend.data[i].itemStyle);
				}
				// console.log('s',this.option.series)
				this.setAmapOption();
				this.chart.setOption(this.option);
			},
			showSelectItem(item) {
				var o = {
					...item,
					value: [item.lng, item.lat, 10]
				};
				this.option.series[this.selectedSeriesIndex].data = [o];
				this.option.series[this.selectedSeriesIndex].name = 'item.title';
				this.setAmapOption();
				this.chart.setOption(this.option);
				//取消刷新地图
				//this.cancelRefresh = true;

				return this.lngLatToContainer(item);
			},
			hideSelectItem() {
				this.option.series[this.selectedSeriesIndex].data = [];
				this.option.series[this.selectedSeriesIndex].name = '';
				this.setAmapOption();
				this.chart.setOption(this.option);
			},
			lngLatToContainer(item) {
				if (!item) {
					return;
				}
				var lnglat = new AMap.LngLat(item.lng, item.lat);
				var pixel = this.amap.lngLatToContainer(lnglat); // 获得 Pixel 对象
				return pixel;
			},
			refreshMap(item) {
				this.setAmapOption();
				this.chart.setOption(this.option);
				return this.lngLatToContainer(item);
			},
			getMapUtil() {
				return this.mapUtil;
			}
		},
	};
</script>
<style scoped>
	#bgmap {
		width: 100%;
		height: 100%;
	}
</style>